export const FreightIcon = () => {
  return (
    <svg width="30" height="25" viewBox="0 0 30 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_7623_16758)">
        <path
          d="M15.0784 1.98438L12.3341 10.315H3.69707L6.74122 12.3488H14.2897L15.0784 9.79356V1.98438Z"
          fill="#01B0FF"
        />
        <path
          d="M7.5489 13.1172H13.911L13.2135 15.4508H15.0191V17.5563H12.5095L11.6621 20.1898L8.01824 22.7646L10.7039 15.3922L7.5489 13.1172Z"
          fill="#3B97D3"
        />
        <path
          d="M22.4569 13.1172H16.0948L16.7988 15.4508H14.9867V17.5563H17.4963L18.3437 20.1898L21.9876 22.7646L19.3084 15.3922L22.4569 13.1172Z"
          fill="#007BCF"
        />
        <path
          d="M15.0788 1.98438L17.8231 10.315H26.4601L23.416 12.3488H15.8741L15.0788 9.79356V1.98438Z"
          fill="#0096FF"
        />
      </g>
      <defs>
        <clipPath id="clip0_7623_16758">
          <rect width="29.3333" height="24" fill="white" transform="translate(0.332901 0.664062)" />
        </clipPath>
      </defs>
    </svg>
  );
};
